import {
  GET_CHIT_GROUPS_REQUEST,
  GET_CHIT_GROUPS_SUCCESS,
  GET_CHIT_GROUPS_FAILURE,
  CREATE_CHIT_GROUP_REQUEST,
  CREATE_CHIT_GROUP_SUCCESS,
  CREATE_CHIT_GROUP_FAILURE,
  GET_CUSTOMER_CHITS_REQUEST,
  GET_CUSTOMER_CHITS_SUCCESS,
  GET_CUSTOMER_CHITS_FAILURE,
  CREATE_CUSTOMER_CHIT_REQUEST,
  CREATE_CUSTOMER_CHIT_SUCCESS,
  CREATE_CUSTOMER_CHIT_FAILURE,
  MAKE_CHIT_PAYMENT_REQUEST,
  MAKE_CHIT_PAYMENT_SUCCESS,
  MAKE_CHIT_PAYMENT_FAILURE,
  GET_CLOSED_CHITS_REQUEST,
  GET_CLOSED_CHITS_SUCCESS,
  GET_CLOSED_CHITS_FAILURE,
  CLOSE_CHIT_EARLY_REQUEST,
  CLOSE_CHIT_EARLY_SUCCESS,
  CLOSE_CHIT_EARLY_FAILURE,
  GET_CHIT_HISTORY_REQUEST,
  GET_CHIT_HISTORY_SUCCESS,
  GET_CHIT_HISTORY_FAILURE,
  GET_CHIT_PAYMENTS_REQUEST,
  GET_CHIT_PAYMENTS_SUCCESS,
  GET_CHIT_PAYMENTS_FAILURE
} from '../types';

const initialState = {
  // Chit Groups
  chitGroups: [],
  chitGroupsLoading: false,
  chitGroupsError: null,
  chitGroupsPagination: null,
  
  // Customer Chits
  customerChits: [],
  customerChitsLoading: false,
  customerChitsError: null,
  customerChitsPagination: null,
  
  // Closed Chits (for billing)
  closedChits: [],
  closedChitsLoading: false,
  closedChitsError: null,
  
  // Chit History
  chitHistory: [],
  chitHistoryLoading: false,
  chitHistoryError: null,
  chitHistoryPagination: null,
  
  // Chit Payments
  chitPayments: [],
  chitPaymentsLoading: false,
  chitPaymentsError: null,
  chitPaymentsPagination: null,
  
  // General loading and error states
  loading: false,
  error: null,
  success: null
};

const chitReducer = (state = initialState, action) => {
  switch (action.type) {
    // Chit Groups
    case GET_CHIT_GROUPS_REQUEST:
      return {
        ...state,
        chitGroupsLoading: true,
        chitGroupsError: null
      };
    case GET_CHIT_GROUPS_SUCCESS:
      return {
        ...state,
        chitGroupsLoading: false,
        chitGroups: action.payload.data,
        chitGroupsPagination: action.payload.pagination
      };
    case GET_CHIT_GROUPS_FAILURE:
      return {
        ...state,
        chitGroupsLoading: false,
        chitGroupsError: action.payload
      };
      
    case CREATE_CHIT_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CREATE_CHIT_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        chitGroups: [action.payload.data, ...state.chitGroups],
        success: action.payload.message
      };
    case CREATE_CHIT_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    // Customer Chits
    case GET_CUSTOMER_CHITS_REQUEST:
      return {
        ...state,
        customerChitsLoading: true,
        customerChitsError: null
      };
    case GET_CUSTOMER_CHITS_SUCCESS:
      return {
        ...state,
        customerChitsLoading: false,
        customerChits: action.payload.data,
        customerChitsPagination: action.payload.pagination
      };
    case GET_CUSTOMER_CHITS_FAILURE:
      return {
        ...state,
        customerChitsLoading: false,
        customerChitsError: action.payload
      };
      
    case CREATE_CUSTOMER_CHIT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CREATE_CUSTOMER_CHIT_SUCCESS:
      return {
        ...state,
        loading: false,
        customerChits: [action.payload.data, ...state.customerChits],
        success: action.payload.message
      };
    case CREATE_CUSTOMER_CHIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    // Chit Payments
    case MAKE_CHIT_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case MAKE_CHIT_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        // Update customer chits with new payment data
        customerChits: state.customerChits.map(chit => 
          chit.id === action.payload.data.customer_chit_id 
            ? { ...chit, ...action.payload.data }
            : chit
        )
      };
    case MAKE_CHIT_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    // Closed Chits
    case GET_CLOSED_CHITS_REQUEST:
      return {
        ...state,
        closedChitsLoading: true,
        closedChitsError: null
      };
    case GET_CLOSED_CHITS_SUCCESS:
      return {
        ...state,
        closedChitsLoading: false,
        closedChits: action.payload.data
      };
    case GET_CLOSED_CHITS_FAILURE:
      return {
        ...state,
        closedChitsLoading: false,
        closedChitsError: action.payload
      };
      
    // Close Chit Early
    case CLOSE_CHIT_EARLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CLOSE_CHIT_EARLY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        // Update customer chits with closure data
        customerChits: state.customerChits.map(chit => 
          chit.id === action.payload.data.id 
            ? { ...chit, ...action.payload.data }
            : chit
        )
      };
    case CLOSE_CHIT_EARLY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    // Chit History
    case GET_CHIT_HISTORY_REQUEST:
      return {
        ...state,
        chitHistoryLoading: true,
        chitHistoryError: null
      };
    case GET_CHIT_HISTORY_SUCCESS:
      return {
        ...state,
        chitHistoryLoading: false,
        chitHistory: action.payload.data,
        chitHistoryPagination: action.payload.pagination
      };
    case GET_CHIT_HISTORY_FAILURE:
      return {
        ...state,
        chitHistoryLoading: false,
        chitHistoryError: action.payload
      };
      
    // Chit Payments
    case GET_CHIT_PAYMENTS_REQUEST:
      return {
        ...state,
        chitPaymentsLoading: true,
        chitPaymentsError: null
      };
    case GET_CHIT_PAYMENTS_SUCCESS:
      return {
        ...state,
        chitPaymentsLoading: false,
        chitPayments: action.payload.data,
        chitPaymentsPagination: action.payload.pagination
      };
    case GET_CHIT_PAYMENTS_FAILURE:
      return {
        ...state,
        chitPaymentsLoading: false,
        chitPaymentsError: action.payload
      };
      
    default:
      return state;
  }
};

export default chitReducer;
